import React from 'react'
import Button from '../../common/button';
import FlagButton from '../../common/flag';

/**
 * @param table
 * @param isOwnTurn
 * @param send
 */
class RoundResult extends React.Component
{

    constructor(props)
    {
        super(props)
        this._keyListener = window.addEventListener("keydown", evt => {
            if (!window._isChatOpen
                    && evt.key == "Enter"
                    && !this.props.table.get("playersReadyForNextRound").includes(this.props.table.get("ownId"))) {
                this.handleReadyForNextHand()
            }
        })
    }

    handleReadyForNextHand()
    {
        this.props.send({ type: "READY_FOR_NEXT_ROUND" })
    }

    handleAbandon()
    {
        getDialog().show({
            content: Messages("table.abandon.description"),
            buttons: [
                { text: Messages("app.cancel") },
                { text: Messages("app.ok"), onClick: () => {
                    this.props.send({ type: "ABANDON" })
                    console.log("ABANDON!")
                    location = "/"
                } }
            ]
        })
    }

    renderPartyEventList(party, result)
    {
        const otherParty = party === "RE" ? "KONTRA" : "RE";
        const events = Object.entries(result.getIn([ "partyPointEvents", party ])
            .reduce((map, v) => { map[v] = (map[v] || 0) + 1; return map }, {}))
            .map(entry => {
                const event = entry[0]
                const count = entry[1]
                const countText = count > 1 ? (" x" + count) : ""
                const points = getPointEventPoints(event) * count
                return (
                    <div key={ event } className="list-item">
                        <div>
                            { Messages(
                                "table.result.event." + event.toLowerCase().replace(/_/g, "-"),
                                Messages("table.player.party." + (event.includes("WRONG") ? otherParty.toLowerCase() : party.toLowerCase()))
                            ) + countText }
                        </div>
                        <div>
                            { points >= 0 ? ("+" + points ) : points }
                        </div>
                    </div>
                )
            })

        return (
            <div className="list dk-box" key={ party }>
                <div className="list-item">{ Messages("table.player.party." + party.toLowerCase()) }</div>
                { events }
                <div className="list-item">
                    <div>{ Messages("table.points.total") }</div>
                    <div>{ result.getIn([ "partyPoints", party ]) }</div>
                </div>
            </div>
        )
    }

    render()
    {
        const t = this.props.table
        const r = t.get("latestRoundResult")

        let winnerHeading = Messages("table.round-result.winner." + (r.get("winningParty") ? r.get("winningParty").toLowerCase() : "none")) 

        let lists = r.get("winningParty") ? this.renderPartyEventList(r.get("winningParty"), r) : [
            this.renderPartyEventList("RE", r),
            this.renderPartyEventList("KONTRA", r)
        ]

        let continueSection

        if (["END_OF_ROUND", "FINISHED"].includes(t.get("status"))) {

            let playersReady = t.get("playersReadyForNextRound").size > 0
                ? Messages("table.round-result.ready-for-next.players", t.get("playersReadyForNextRound").map(id => t.get("players").find(pl => pl.get("id") == id).get("name")).join(", "))
                : null

            continueSection = [
                playersReady ? (<div key="pl">{ playersReady }</div>) : null,
                <div key="rdy" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <Button
                        className="dk-box"
                        onClick={ this.handleReadyForNextHand.bind(this) }
                        text={ Messages("table.round-result.ready-" + (t.get("status") === "FINISHED" ? "to-continue" : "for-next")) + " (Enter)" }
                        disabled={ t.get("playersReadyForNextRound").includes(t.get("ownId")) }
                    />
                    <FlagButton
                        style={{ marginLeft: 15 }}
                        onClick={ this.handleAbandon.bind(this) }
                    />
                </div>
            ]
        } else {
            continueSection = (
                <div>{ Messages("table.round-result.last") }</div>
            )
        }

        let flaggedPlayer = t.get("players").filter(p => p.get("timeRemaining") === 0).get(0)
        let flaggedInfo = flaggedPlayer ? (
            <div className="subheading">{ Messages("game.flagged", flaggedPlayer.get("name")) }</div>
        ) : null

        return (
            <div className="center-content round-result">
                <div className="heading">{ winnerHeading }</div>
                { flaggedInfo }
                <div className="subheading">
                    { Messages("table.player.party.re") + ": " + r.getIn([ "partyCardPoints", "RE" ])
                        + ", " + Messages("table.player.party.kontra") + ": " + r.getIn([ "partyCardPoints", "KONTRA" ]) }
                </div>
                { continueSection }
                <div className="list-container">
                    { lists }
                </div>
            </div>
        )
    }

}

export function getPointEventPoints(e)
{
    if ([ "ANNOUNCEMENT_PARTY", "ANNOUNCEMENT_PARTY_WRONG" ].includes(e)) {
        return 2
    }
    return e.startsWith("OPPONENT") ? -1 : 1
}

export default RoundResult
export { RoundResult }